const steps = [
  { number: "01", icon: "ri-phone-line", title: "Call or Apply Online", description: "Contact us or start your application online at fastpassportcenter.com. We assess your timeline, confirm your eligibility, and recommend the right service level for your departure date." },
  { number: "02", icon: "ri-file-list-3-line", title: "Gather Your Documents", description: "We provide a personalized checklist for your situation. ETSU students, Mountain States medical professionals, and first-time applicants each have different requirements — we guide you through all of them." },
  { number: "03", icon: "ri-camera-line", title: "Get Passport Photos", description: "Visit CVS, Walgreens, or UPS Store in Johnson City or Jonesborough. We verify your photos meet exact State Department standards before submission — catching errors that would cause rejection." },
  { number: "04", icon: "ri-mail-send-line", title: "Submit Your Application", description: "We handle submission via our registered State Department courier service. No post office line, no appointment needed at a government agency, no 100-mile drive to Knoxville." },
  { number: "05", icon: "ri-passport-line", title: "Receive Your Passport", description: "Your passport arrives via secure overnight shipping to your Johnson City, Jonesborough, or Washington County address. Track every step and receive email updates throughout the process." },
];

export default function JohnsonCityHowItWorksSection() {
  return (
    <section id="how-it-works" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">How It Works</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            5 Simple Steps to Your Passport
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Getting your passport in Johnson City is simple with our guided process — no government office visits, no Knoxville drive, no surprises.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-0.5 bg-[#EEF2F8]" style={{ marginLeft: "10%", marginRight: "10%" }}></div>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            {steps.map((step, i) => (
              <div key={i} className="relative flex flex-col items-center text-center">
                <div className="relative z-10 w-20 h-20 flex items-center justify-center rounded-full bg-white border-4 border-[#EEF2F8] mb-5">
                  <i className={`${step.icon} text-[#1A365D] text-2xl`}></i>
                  <span className="absolute -top-2 -right-2 w-7 h-7 flex items-center justify-center bg-[#F6C344] text-[#1A365D] text-xs font-bold rounded-full">
                    {step.number}
                  </span>
                </div>
                <h3 className="font-serif font-bold text-[#1A365D] text-base mb-3">{step.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] text-[#1A365D] font-semibold px-10 py-4 rounded-lg hover:bg-[#e5b33f] transition-all whitespace-nowrap"
          >
            <i className="ri-passport-line"></i>
            Start My Application Now
          </a>
          <p className="text-gray-400 text-sm mt-4">Processing options available from 24 hours to 3 weeks</p>
        </div>
      </div>
    </section>
  );
}